import { render } from "./general.vue?vue&type=template&id=47607d4f&ts=true"
import script from "./general.vue?vue&type=script&lang=ts"
export * from "./general.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__